<template>
  <layout-default>
    <template v-slot:toolbar> </template>
    <div class="page-notifications">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="page-notifications-wrapper">
        <v-tabs
          class="page-notifications-tabs"
          v-model="tab"
          fixed-tabs
          @change="loadNotifications"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab>All</v-tab>
          <v-tab>Unread</v-tab>
        </v-tabs>
        <v-tabs-items class="page-notifications-v-tabs-items" v-model="tab">
          <v-tab-item>
            <v-container class="page-notifications-card-container">
              <notification
                v-for="notification in notifications.items"
                :key="notification.id"
                :notification="notification"
              />
              <h5
                class="text-center pt-8"
                v-if="notifications.items.length == 0"
              >
                All clear, have a nice day!
              </h5>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container class="page-notifications-card-container">
              <notification
                v-for="notification in filteredNotifications"
                :key="notification.id"
                :notification="notification"
              />
              <h5
                class="text-center pt-8"
                v-if="filteredNotifications.length == 0"
              >
                All clear, have a nice day!
              </h5>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import Notification from '@/components/notifications/Notification.vue'

export default {
  name: 'Library',
  components: {
    LayoutDefault,
    Notification,
  },
  data() {
    return {
      loading: false,
      tab: null,
    }
  },
  computed: {
    ...mapState('userStates', ['notifications', 'profileId']),
    filteredNotifications() {
      // bugfix for situation, when new notification signal causes to get all notifications, even if we are on unread notifications tab
      let notifs = [...this.notifications.items]
      return notifs.filter(item => item.unread == true)
    },
    params() {
      //unused, filtering frontend side
      const defaultQueryParams = new URLSearchParams()
      defaultQueryParams.append('filter', this.tab ? 'unread' : 'all')
      return defaultQueryParams
    },
  },
  created() {
    this.getNotifications({
      isAdvisor: this.$store.getters['dictionariesStates/isAdvisor'],
    })
  },
  methods: {
    ...mapActions('userStates', ['getNotifications']),
    loadNotifications() {
      this.getNotifications({
        isAdvisor: this.$store.getters['dictionariesStates/isAdvisor'],
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.page-notifications {
  background: $bh-white;
  padding: 16px 2 * $gutter 0;
  height: 100%;
  &-breadcrumbs {
  }
  &-heading {
    color: $bh-gray--2;
    font-size: 1rem;
    padding-left: 8px;
  }
  &-wrapper {
    width: 500px;
    margin: 0 auto;
  }
  &-tabs {
    padding: 0 24px;
    background: #ffffff;
    .v-tab {
      color: $bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color: white;
      }
    }
    .v-tabs-slider {
      background: $bh-blue;
    }
  }
  &-v-tabs-items {
  }
}
.v-card__title {
  word-break: normal;
}
</style>
